<template>
  <v-app>
    <div class="signup-selector-page">
      <v-container class="signup-container">
        <v-row justify="center" align="center" class="min-height-screen">
          <v-col cols="12">
            <!-- Header Section -->
            <div class="text-center mb-10">
              <h1 class="main-title">Join AutoSyncX™</h1>
              <p class="subtitle">Choose how you want to participate in the AutoSyncX™ marketplace.</p>
            </div>

            <!-- Cards Section -->
            <v-row justify="center" class="cards-row">
              <!-- Dealership Card -->
              <v-col cols="12" sm="6" md="4" lg="4">
                <div class="glass-card card-purple">
                  <div class="card-icon purple">
                    <i class="material-icons-round" style="color:white;">store</i>
                  </div>
                  <h3 class="card-title">Dealership</h3>
                  <p class="card-subtitle">For vehicle dealers listing inventory and paying per referral</p>

                  <ul class="feature-list">
                    <li><i class="material-icons-round check">check</i> List your inventory on AutoSyncX™</li>
                    <li><i class="material-icons-round check">check</i> Set your referral payout per sale</li>
                    <li><i class="material-icons-round check">check</i> Receive qualified buyers from agents</li>
                    <li><i class="material-icons-round check">check</i> Track views, clicks, and leads per vehicle</li>
                  </ul>

                  <v-btn class="signup-btn" block @click="goToDealerSignup">
                    Sign Up as<br>a Dealership
                  </v-btn>
                </div>
              </v-col>

              <!-- Sales Agent Card -->
              <v-col cols="12" sm="6" md="4" lg="4">
                <div class="glass-card card-pink">
                  <div class="card-icon pink">
                    <i class="material-icons-round" style="color:white;">person</i>
                  </div>
                  <h3 class="card-title">Sales Agent</h3>
                  <p class="card-subtitle">For licensed sellers who close deals, and can also recruit dealers</p>

                  <ul class="feature-list">
                    <li><i class="material-icons-round check">check</i> Sell vehicles from approved dealerships</li>
                    <li><i class="material-icons-round check">check</i> Earn commissions on completed sales</li>
                    <li><i class="material-icons-round check">check</i> Optionally sign up dealerships</li>
                    <li><i class="material-icons-round check">check</i> Optionally refer other agents</li>
                  </ul>

                  <v-btn class="signup-btn" block @click="goToSalesAgentSignup">
                    Sign Up as<br>a Sales Agent
                  </v-btn>
                </div>
              </v-col>

              <!-- Referring Agent Card -->
              <v-col cols="12" sm="6" md="4" lg="4">
                <div class="glass-card card-cyan">
                  <div class="card-icon cyan">
                    <i class="material-icons-round" style="color:white;">campaign</i>
                  </div>
                  <h3 class="card-title">Referring Agent</h3>
                  <p class="card-subtitle">For promoters who refer buyers, not sell vehicles</p>

                  <ul class="feature-list">
                    <li><i class="material-icons-round check">check</i> Share inventory on your personal card</li>
                    <li><i class="material-icons-round check">check</i> Refer buyers to dealerships</li>
                    <li><i class="material-icons-round check">check</i> Earn commissions on completed sales</li>
                    <li><i class="material-icons-round close">close</i> No selling or deal closing responsibility</li>
                  </ul>

                  <v-btn class="signup-btn" block @click="goToReferringAgentSignup">
                    Sign Up as<br>a Referring Agent
                  </v-btn>
                </div>
              </v-col>
            </v-row>

            <!-- Back to Login Link -->
            <div class="text-center mt-10">
              <span class="login-text">Already have an account? </span>
              <a @click="goToLogin" class="login-link">Log in</a>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'SignupSelector',
  methods: {
    goToDealerSignup() {
      this.$router.push('/dealers/signup')
    },
    goToSalesAgentSignup() {
      this.$router.push('/form-sales/0')
    },
    goToReferringAgentSignup() {
      this.$router.push('/signup-agent')
    },
    goToLogin() {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.signup-selector-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a0a2e 0%, #2d1b4e 25%, #1a0a2e 50%, #0d0620 100%);
  position: relative;
  overflow: hidden;
}

.signup-selector-page::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(ellipse at 20% 20%, rgba(138, 43, 226, 0.3) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 80%, rgba(219, 112, 147, 0.25) 0%, transparent 50%),
    radial-gradient(ellipse at 50% 50%, rgba(75, 0, 130, 0.2) 0%, transparent 60%);
  pointer-events: none;
}

.signup-selector-page::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    radial-gradient(2px 2px at 20px 30px, white, transparent),
    radial-gradient(2px 2px at 40px 70px, rgba(255,255,255,0.8), transparent),
    radial-gradient(1px 1px at 90px 40px, white, transparent),
    radial-gradient(2px 2px at 160px 120px, rgba(255,255,255,0.9), transparent),
    radial-gradient(1px 1px at 230px 80px, white, transparent),
    radial-gradient(2px 2px at 300px 150px, rgba(255,255,255,0.7), transparent),
    radial-gradient(1px 1px at 350px 200px, white, transparent),
    radial-gradient(2px 2px at 420px 50px, rgba(255,255,255,0.8), transparent),
    radial-gradient(1px 1px at 500px 180px, white, transparent),
    radial-gradient(2px 2px at 580px 90px, rgba(255,255,255,0.9), transparent);
  background-size: 600px 250px;
  animation: stars 100s linear infinite;
  pointer-events: none;
}

@keyframes stars {
  from { background-position: 0 0; }
  to { background-position: 600px 250px; }
}

.signup-container {
  position: relative;
  z-index: 1;
  max-width: 1200px;
}

.min-height-screen {
  min-height: 100vh;
  padding: 40px 0;
}

.main-title {
  font-size: 2.8rem;
  font-weight: 300;
  color: #ffffff;
  margin-bottom: 0.5rem;
  letter-spacing: 1px;
}

.subtitle {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 300;
}

.cards-row {
  margin-top: 20px;
}

.glass-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.03) 100%);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 30px 25px;
  text-align: center;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.glass-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

/* Purple Card - Dealership */
.glass-card.card-purple {
  border-color: rgba(147, 51, 234, 0.5);
  box-shadow: 0 0 20px rgba(147, 51, 234, 0.15);
}

.glass-card.card-purple:hover {
  border-color: rgba(147, 51, 234, 0.8);
  box-shadow: 0 0 30px rgba(147, 51, 234, 0.3), 0 20px 40px rgba(0, 0, 0, 0.3);
}

/* Pink Card - Sales Agent */
.glass-card.card-pink {
  border-color: rgba(236, 72, 153, 0.5);
  box-shadow: 0 0 20px rgba(236, 72, 153, 0.15);
}

.glass-card.card-pink:hover {
  border-color: rgba(236, 72, 153, 0.8);
  box-shadow: 0 0 30px rgba(236, 72, 153, 0.3), 0 20px 40px rgba(0, 0, 0, 0.3);
}

/* Cyan Card - Referring Agent */
.glass-card.card-cyan {
  border-color: rgba(34, 211, 238, 0.5);
  box-shadow: 0 0 20px rgba(34, 211, 238, 0.15);
}

.glass-card.card-cyan:hover {
  border-color: rgba(34, 211, 238, 0.8);
  box-shadow: 0 0 30px rgba(34, 211, 238, 0.3), 0 20px 40px rgba(0, 0, 0, 0.3);
}

.card-icon {
  margin-bottom: 15px;
}

.card-icon i {
  font-size: 48px;
  color: rgba(255, 255, 255, 0.85);
}

.card-icon.purple i {
  color: rgba(167, 139, 250, 0.9);
}

.card-icon.pink i {
  color: rgba(244, 114, 182, 0.9);
}

.card-icon.cyan i {
  color: rgba(34, 211, 238, 0.9);
}

.card-title {
  font-size: 1.5rem;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 8px;
}

.card-subtitle {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 20px;
  line-height: 1.4;
  min-height: 40px;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0 0 25px 0;
  text-align: left;
  flex-grow: 1;
}

.feature-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.4;
}

.feature-list li i.check {
  color: #a855f7;
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 1px;
}

.feature-list li i.close {
  color: rgba(255, 255, 255, 0.4);
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 1px;
}

.signup-btn {
  background: linear-gradient(135deg, rgba(168, 85, 247, 0.4) 0%, rgba(139, 92, 246, 0.3) 100%) !important;
  border: 1px solid rgba(168, 85, 247, 0.5) !important;
  color: #ffffff !important;
  text-transform: none !important;
  font-weight: 500;
  font-size: 0.95rem;
  letter-spacing: 0;
  border-radius: 8px !important;
  padding: 12px 20px !important;
  height: auto !important;
  line-height: 1.3;
  transition: all 0.3s ease;
}

.signup-btn:hover {
  background: linear-gradient(135deg, rgba(168, 85, 247, 0.6) 0%, rgba(139, 92, 246, 0.5) 100%) !important;
  border-color: rgba(168, 85, 247, 0.7) !important;
}

.login-text {
  color: rgba(255, 255, 255, 0.5);
}

.login-link {
  color: #a855f7;
  cursor: pointer;
  font-weight: 500;
  text-decoration: none;
}

.login-link:hover {
  text-decoration: underline;
}

@media (max-width: 960px) {
  .glass-card {
    margin-bottom: 20px;
  }
}

@media (max-width: 600px) {
  .main-title {
    font-size: 2rem;
  }

  .subtitle {
    font-size: 0.95rem;
  }

  .glass-card {
    padding: 25px 20px;
  }
}
</style>

